import {forwardRef, Inject, Injectable, Injector} from '@angular/core';
import {
    HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,
    HttpResponse
} from '@angular/common/http';
import {Router} from '@angular/router';
import {Observable, throwError} from 'rxjs';
import {catchError,map} from 'rxjs/operators';


@Injectable()
export class HTTPResponseInterceptorService  implements HttpInterceptor {


    constructor(private _router:Router) {} // Angular DI

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


        console.log('Http Response Interceptor');

        return next.handle(req).pipe(catchError(err => {
            if (err instanceof HttpErrorResponse) {

                const errResp = <HttpErrorResponse>err;
                if (errResp.status === 401 || errResp.status === 403) {
                    console.log(' You are logged out');

                    localStorage.removeItem('user');
                    localStorage.removeItem('project_id');

                    this._router.navigate(['/login']);
                }
                // return the error back to the caller
                return throwError(errResp);
            }
        }));

    }

}
